import React from 'react'

export function hasClassNameOrParent(event: React.MouseEvent<HTMLElement>, className: string): boolean {
    let element: HTMLElement | null = event.target as HTMLElement
    while (element && element !== event.currentTarget) {
        if (element.classList && element.classList.contains(className)) {
            return true
        }
        element = element.parentElement
    }

    // Check the currentTarget (the element the event listener is attached to) as well
    return event.currentTarget.classList.contains(className)
}
